import { render } from "./memberCard.vue?vue&type=template&id=ff8c3dc8&scoped=true&ts=true"
import script from "./memberCard.vue?vue&type=script&lang=ts"
export * from "./memberCard.vue?vue&type=script&lang=ts"

import "./memberCard.vue?vue&type=style&index=0&id=ff8c3dc8&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8c3dc8"]])

export default __exports__